import { render, staticRenderFns } from "./CandidateTags.html?vue&type=template&id=5bf25030&scoped=true&external"
import script from "./CandidateTags.js?vue&type=script&lang=js&external"
export * from "./CandidateTags.js?vue&type=script&lang=js&external"
import style0 from "./CandidateTags.scss?vue&type=style&index=0&id=5bf25030&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf25030",
  null
  
)

export default component.exports